function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}
module.exports = _isNumber;


//////////////////
// WEBPACK FOOTER
// ../~/ramda/src/internal/_isNumber.js
// module id = 807
// module chunks = 0